import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { HeaderTemplate, KeyValue, Stepper, TitleHeader } from 'web-library';
import { useGetGroupWithdrawalSummary } from '../../../api/candidate/exam/@coordinator/queries-services/queries';
import Review from '../../../modules/withdrawal/components/coordinator/Review';

const ReviewPage = ({ routeSteps }: { routeSteps: { label: string }[] }) => {
  const { t } = useTranslation();
  const { uuid } = useParams<{ uuid: string }>();

  const { data: summaryResponse } = useGetGroupWithdrawalSummary(uuid);

  return (
    <>
      <TitleHeader title={t('withdrawal->>Coordinator.Header.TitleHeader')} />
      {summaryResponse && (
        <>
          <HeaderTemplate>
            <KeyValue
              keyText={t('withdrawal->>Coordinator.Header.ExamLevel')}
              valueText={summaryResponse.examType?.description}
            />
            <Stepper activeStep={2} steps={routeSteps} />
          </HeaderTemplate>
          <Review
            lastUpdatedTime={summaryResponse.lastUpdatedTime}
            examTypeCode={summaryResponse.examType.code}
          />
        </>
      )}
    </>
  );
};

export default ReviewPage;
